export const AVAILABLE_BADGES = [
  { id: 'first_step', nameKey: 'badge_first_step', descKey: 'badge_first_step_desc', icon: 'Footprints' },
  { id: 'chapter_1_master', nameKey: 'badge_chapter_1_master', descKey: 'badge_chapter_1_master_desc', icon: 'TriangleAlert' },
  { id: 'night_owl', nameKey: 'badge_night_owl', descKey: 'badge_night_owl_desc', icon: 'Moon' },
  { id: 'streak_3', nameKey: 'badge_streak_3', descKey: 'badge_streak_3_desc', icon: 'Flame' },
  { id: 'streak_7', nameKey: 'badge_streak_7', descKey: 'badge_streak_7_desc', icon: 'Zap' },
  { id: 'exam_ready', nameKey: 'badge_exam_ready', descKey: 'badge_exam_ready_desc', icon: 'Trophy' },
  { id: 'bookmark_king', nameKey: 'badge_bookmark_king', descKey: 'badge_bookmark_king_desc', icon: 'Bookmark' }
];
